export default {
	arce: null
}